import { useMutation } from 'react-query';

import { useCompanyId } from 'modules/app/hooks/useCompanyId';
import { deleteV2ApiCompanyIdTravelEntityTypeEntityIdTrip } from 'src/client/spendesk-api';

export const useDeleteEntityTripMutation = ({
  entityType,
  entityId,
}: {
  entityType: 'requests' | 'payments' | 'payables';
  entityId: string;
}) => {
  const companyId = useCompanyId();

  return useMutation(
    [entityType, entityId, 'trip'],
    async () => {
      const response = await deleteV2ApiCompanyIdTravelEntityTypeEntityIdTrip({
        path: { companyId, entityType, entityId },
      });

      if (response.statusCode !== 204) {
        throw new Error(`Failed to update trip for ${entityType} ${entityId}`);
      }
      return response.body;
    },
    {
      retry: false,
    },
  );
};
